import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { fg } from '@atlaskit/platform-feature-flags';
import { getXChannelIdHeader, getXProductHeader } from '@atlassian/editor-ai-common/api/request';
import { FAILURE_REASON } from '../errors';
function parsedHasExpectedKey(key, parsed) {
  if (_typeof(parsed) !== 'object' || parsed === null || !(key in parsed)) {
    return false;
  }
  return true;
}
function sanitizeErrorContent(error) {
  if (typeof error === 'string') {
    return error;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unknown error: ".concat(error === null ? 'null' : error === null || error === void 0 ? void 0 : error.toString());
}
function handleRequestError(error) {
  var isErrorUnknown = parsedHasExpectedKey('name', error) && error.name === 'AbortError' || parsedHasExpectedKey('cause', error) && error.cause === 'ConvoAIChannelCreationError';

  // This can be due to code crashes too, but falls back to network errors
  if (!isErrorUnknown) {
    // eslint-disable-next-line no-console
    console.error('Editor AI: startStreamingResponse()', error);
  }
  return {
    type: 'error',
    errorInfo: {
      failureReason: FAILURE_REASON.API_FAIL,
      statusCode: parsedHasExpectedKey('status', error) ? Number(error.status) : undefined,
      errorContent: sanitizeErrorContent(error)
    }
  };
}

// For non 200 status codes
// See details https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-codes
function handleResponseNotOK(_x2) {
  return _handleResponseNotOK.apply(this, arguments);
}
function _handleResponseNotOK() {
  _handleResponseNotOK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var cacheKey, selection, response, knownErrors, _yield$response$json, error, retryAfter;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cacheKey = _ref.cacheKey, selection = _ref.selection, response = _ref.response;
          if (!(response.status === 400)) {
            _context2.next = 20;
            break;
          }
          _context2.prev = 2;
          // Errors with special handling
          // We have soft alignment with the BE that for inputs that are not suitable
          // for prompts -- we want to rely on openai providing a suitable message for
          // the user. And not have manually maintained guards/user feedback messages.
          // https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3573548013/Introducing+AI+Dev+Documentation+TODO+AIFOLLOWUP+audit
          knownErrors = ['INPUT_TOO_SHORT_TO_SUMMARIZE', 'INPUT_TOO_SHORT_TO_PROCESS', 'INPUT_EXCEEDS_TOKEN_LIMIT'];
          _context2.next = 6;
          return response.json();
        case 6:
          _yield$response$json = _context2.sent;
          error = _yield$response$json.error;
          if (!error) {
            _context2.next = 15;
            break;
          }
          if (!(_typeof(error) === 'object' && 'key' in error && knownErrors.includes(error.key))) {
            _context2.next = 14;
            break;
          }
          if (!(error.key === 'INPUT_EXCEEDS_TOKEN_LIMIT')) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.TOKEN_LIMIT,
              statusCode: response.status,
              errorKey: error.key
            }
          });
        case 12:
          if (!(error.key === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || error.key === 'INPUT_TOO_SHORT_TO_PROCESS')) {
            _context2.next = 14;
            break;
          }
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.INPUT_TOO_SHORT,
              statusCode: response.status,
              errorKey: error.key
            }
          });
        case 14:
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.API_FAIL,
              statusCode: response.status,
              errorContent: 'Unhandled error response received'
            }
          });
        case 15:
          _context2.next = 20;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](2);
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.API_FAIL,
              statusCode: response.status,
              errorContent: sanitizeErrorContent(_context2.t0)
            }
          });
        case 20:
          if (!(response.status === 429)) {
            _context2.next = 23;
            break;
          }
          retryAfter = response.headers.get('Retry-After') || '60';
          return _context2.abrupt("return", {
            type: 'error',
            retryAfter: Number(retryAfter),
            errorInfo: {
              failureReason: FAILURE_REASON.RATE_LIMITED,
              statusCode: response.status
            }
          });
        case 23:
          if (!(response.status === 451)) {
            _context2.next = 25;
            break;
          }
          return _context2.abrupt("return", {
            type: 'error',
            cacheKey: cacheKey,
            modelInput: {
              selection: selection
            },
            errorInfo: {
              failureReason: FAILURE_REASON.AUP_VIOLATION,
              statusCode: 451
            }
          });
        case 25:
          if (!(response.status === 9001)) {
            _context2.next = 27;
            break;
          }
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.ELEVATE_DISABLED_GENERATE,
              statusCode: 9001
            }
          });
        case 27:
          return _context2.abrupt("return", {
            type: 'error',
            errorInfo: {
              failureReason: FAILURE_REASON.API_FAIL,
              statusCode: response.status,
              errorContent: "unexpected response status: ".concat(response.status)
            }
          });
        case 28:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 17]]);
  }));
  return _handleResponseNotOK.apply(this, arguments);
}
function handleNoResponseBody(response) {
  return {
    type: 'error',
    errorInfo: {
      failureReason: FAILURE_REASON.API_FAIL,
      statusCode: response.status,
      errorContent: 'response.body missing'
    }
  };
}
function handleLineNoGeneratedContent(_ref2) {
  var _data$error, _data$error2;
  var cacheKey = _ref2.cacheKey,
    selection = _ref2.selection,
    data = _ref2.data;
  if (((_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.statusCode) === 429) {
    return {
      type: 'error',
      retryAfter: 60,
      errorInfo: {
        failureReason: FAILURE_REASON.RATE_LIMITED,
        statusCode: 429
      }
    };
  }
  if (((_data$error2 = data.error) === null || _data$error2 === void 0 ? void 0 : _data$error2.key) === 'RESPONSE_TOO_SIMILAR') {
    var inputOutputDiffRatio = parsedHasExpectedKey('meta', data) && parsedHasExpectedKey('inputOutputDiffRatio', data.meta) ? data['meta']['inputOutputDiffRatio'] : '';
    return {
      type: 'response too similar',
      cacheKey: cacheKey,
      modelInput: {
        selection: selection
      },
      inputOutputDiffRatio: inputOutputDiffRatio
    };
  }
  return {
    type: 'error',
    errorInfo: {
      failureReason: FAILURE_REASON.API_FAIL
    }
  };
}
function handleLineGeneratedContent(_ref3) {
  var streamContentProcessor = _ref3.streamContentProcessor,
    partial = _ref3.partial,
    data = _ref3.data;
  partial.content += data['generatedContent'];
  if (parsedHasExpectedKey('meta', data) && parsedHasExpectedKey('inputOutputDiffRatio', data.meta)) {
    partial.meta = {
      inputOutputDiffRatio: data['meta']['inputOutputDiffRatio'],
      loadingStatus: ''
    };
  }
  return _objectSpread({
    type: 'stream',
    loadingStatus: partial.meta.loadingStatus,
    markdown: partial.content
  }, streamContentProcessor === null || streamContentProcessor === void 0 ? void 0 : streamContentProcessor(partial.content));
}

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function handleLineConvoAITrace(_ref4) {
  var partial = _ref4.partial,
    data = _ref4.data;
  var loadingStatus = parsedHasExpectedKey('message', data) && parsedHasExpectedKey('message_template', data.message) ? data.message.message_template : '';
  partial.meta = {
    inputOutputDiffRatio: '',
    loadingStatus: loadingStatus
  };
}

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function handleLineConvoAIAnswerPart(_ref5) {
  var partial = _ref5.partial,
    data = _ref5.data;
  partial.content += data.message.content;
  partial.meta = {
    inputOutputDiffRatio: '',
    loadingStatus: ''
  };
}
function handleLineConvoAIFinalResponse(_ref6) {
  var _message$message2;
  var cacheKey = _ref6.cacheKey,
    selection = _ref6.selection,
    partial = _ref6.partial,
    data = _ref6.data;
  var message = data.message;

  // if response too similar, early break/return
  if (parsedHasExpectedKey('message_metadata', message.message) && parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) {
    var _message$message;
    return {
      type: 'response too similar',
      cacheKey: cacheKey,
      modelInput: {
        selection: selection
      },
      inputOutputDiffRatio: ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message_metadata) === null || _message$message === void 0 ? void 0 : _message$message.diff_ratio) || ''
    };
  }
  if (fg('migrate_editor_issue_reformatter_to_convo-ai')) {
    // Handle data from the Convo AI service, which has a different data structure
    // If 'content' is a direct property of 'message', it indicates a Convo AI response
    // This ensures compatibility with future changes
    // when migrating the whole issue reformatter from assistant service to Convo AI
    if (message.content) {
      partial.content = message.content;
      partial.rovoActions = message.actions || [];
      // Convo ai does not support diff_ratio currently, keep the property for compatibility
      partial.meta = {
        inputOutputDiffRatio: '',
        loadingStatus: ''
      };
      return;
    }
  }
  partial.content = message.message.content;
  partial.rovoActions = message.message.actions || [];
  partial.meta = {
    inputOutputDiffRatio: ((_message$message2 = message.message) === null || _message$message2 === void 0 || (_message$message2 = _message$message2.message_metadata) === null || _message$message2 === void 0 ? void 0 : _message$message2.diff_ratio) || '',
    loadingStatus: ''
  };
}
function handleLineConvoAIError(_ref7) {
  var cacheKey = _ref7.cacheKey,
    selection = _ref7.selection,
    data = _ref7.data;
  var statusCode;
  var guard = 'UNHANDLED_ERROR';
  var error;
  var retryAfter;
  if (parsedHasExpectedKey('message', data)) {
    // Get status code
    if (parsedHasExpectedKey('status_code', data.message) && typeof data.message.status_code === 'number') {
      statusCode = data.message.status_code;
    }

    // Get reason
    if (parsedHasExpectedKey('message_template', data.message)) {
      guard = data.message.message_template;
    }

    // Get error
    if (parsedHasExpectedKey('content', data.message)) {
      error = data.message.content;
    }

    // Get retryAfter
    if (parsedHasExpectedKey('headers', data) && parsedHasExpectedKey('Retry-After', data.headers)) {
      retryAfter = Number(data.headers['Retry-After']);
    }
  }
  var failureReason = FAILURE_REASON.API_FAIL;
  if (['RATE_LIMIT', 'OPENAI_RATE_LIMIT_USER_ABUSE'].includes(guard) && retryAfter) {
    failureReason = FAILURE_REASON.RATE_LIMITED;
  } else {
    retryAfter = undefined;
  }
  if (guard === 'HIPAA_CONTENT_DETECTED') {
    failureReason = FAILURE_REASON.HIPAA_CONTENT;
  }
  if (guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') {
    failureReason = FAILURE_REASON.TOKEN_LIMIT;
  }
  if (guard === 'ACCEPTABLE_USE_VIOLATIONS') {
    return {
      type: 'error',
      cacheKey: cacheKey,
      modelInput: {
        selection: selection
      },
      errorInfo: {
        failureReason: FAILURE_REASON.AUP_VIOLATION,
        statusCode: statusCode,
        errorKey: guard,
        apiName: 'assistance-service',
        errorContent: sanitizeErrorContent(error)
      }
    };
  }
  if (retryAfter) {
    return {
      type: 'error',
      retryAfter: retryAfter,
      errorInfo: {
        apiName: 'assistance-service',
        failureReason: failureReason,
        statusCode: statusCode,
        errorKey: guard,
        errorContent: sanitizeErrorContent(error)
      }
    };
  }
  return {
    type: 'error',
    errorInfo: {
      apiName: 'assistance-service',
      failureReason: failureReason,
      statusCode: statusCode,
      errorKey: guard,
      errorContent: sanitizeErrorContent(error)
    }
  };
}
function handleLineConvoAI(_ref8) {
  var cacheKey = _ref8.cacheKey,
    selection = _ref8.selection,
    partial = _ref8.partial,
    data = _ref8.data;
  if (parsedHasExpectedKey('type', data)) {
    switch (data.type) {
      case 'TRACE':
        handleLineConvoAITrace({
          partial: partial,
          data: data
        });
        break;
      case 'ANSWER_PART':
        handleLineConvoAIAnswerPart({
          partial: partial,
          data: data
        });
        break;
      case 'FINAL_RESPONSE':
        var error = handleLineConvoAIFinalResponse({
          cacheKey: cacheKey,
          selection: selection,
          partial: partial,
          data: data
        });
        if (error) {
          return error;
        }
        break;
      case 'ERROR':
        return handleLineConvoAIError({
          cacheKey: cacheKey,
          selection: selection,
          data: data
        });
    }
  }
  // If there are any unexpected loading responses, we should return the current data
  return {
    type: 'stream',
    loadingStatus: partial.meta.loadingStatus,
    markdown: partial.content
  };
}
function handleLine(_ref9) {
  var cacheKey = _ref9.cacheKey,
    selection = _ref9.selection,
    isConvoAI = _ref9.isConvoAI,
    streamContentProcessor = _ref9.streamContentProcessor,
    partial = _ref9.partial,
    data = _ref9.data;
  if (parsedHasExpectedKey('generatedContent', data)) {
    return handleLineGeneratedContent({
      streamContentProcessor: streamContentProcessor,
      partial: partial,
      data: data
    });
  } else if (isConvoAI) {
    return handleLineConvoAI({
      cacheKey: cacheKey,
      selection: selection,
      partial: partial,
      data: data
    });
  } else {
    // if not expected response from the API the we have an error
    return {
      type: 'error',
      errorInfo: {
        failureReason: FAILURE_REASON.API_FAIL
      }
    };
  }
}
function handleLoaded(_ref10) {
  var _partial$meta2;
  var cacheKey = _ref10.cacheKey,
    selectionType = _ref10.selectionType,
    selection = _ref10.selection,
    streamContentProcessor = _ref10.streamContentProcessor,
    isComplete = _ref10.isComplete,
    partial = _ref10.partial;
  var rovoActions = partial.rovoActions || [];
  var markdown = partial.content;
  var processedResponse = {
    markdown: markdown
  };
  if (rovoActions.length > 0) {
    var _rovoActions$find;
    var idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
    var action = (_rovoActions$find = rovoActions.find(function (x) {
      return x.data.suggestion === idealSuggestion;
    })) !== null && _rovoActions$find !== void 0 ? _rovoActions$find : rovoActions[0];

    // There is a scenario where we are in selectionType === 'empty'
    // but AI returns replace. In this case, we override the replace
    // suggestion with insert.
    if (selectionType === 'empty' && action.data.suggestion === 'replace') {
      // This should also update the value by reference in rovoActions
      action.data.suggestion = 'insert';
    }
    // The opposite can happen too
    else if (selectionType === 'range' && action.data.suggestion === 'insert') {
      // This should also update the value by reference in rovoActions
      action.data.suggestion = 'replace';
    }
    markdown += "\n\n---\n\n".concat(action.data.content);
  } else if (streamContentProcessor) {
    processedResponse = streamContentProcessor(partial.content);
  }
  if (isComplete) {
    var isCompleted = isComplete();
    if (!isCompleted) {
      var _partial$meta;
      return _objectSpread(_objectSpread({
        type: 'stream'
      }, processedResponse), {}, {
        loadingStatus: (_partial$meta = partial.meta) === null || _partial$meta === void 0 ? void 0 : _partial$meta.loadingStatus
      });
    }
  }
  return _objectSpread(_objectSpread({
    type: 'complete'
  }, processedResponse), {}, {
    cacheKey: cacheKey,
    modelInput: {
      selection: selection
    },
    inputOutputDiffRatio: (_partial$meta2 = partial.meta) === null || _partial$meta2 === void 0 ? void 0 : _partial$meta2.inputOutputDiffRatio,
    rovoActions: rovoActions
  });
}
function streamingBody(_x) {
  return _streamingBody.apply(this, arguments);
}
function _streamingBody() {
  _streamingBody = _wrapAsyncGenerator(function (_ref11) {
    var cacheKey = _ref11.cacheKey,
      selectionType = _ref11.selectionType,
      selection = _ref11.selection,
      isConvoAI = _ref11.isConvoAI,
      streamContentProcessor = _ref11.streamContentProcessor,
      isComplete = _ref11.isComplete,
      response = _ref11.response,
      body = _ref11.body;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var reader, decoder, buffer, done, partial, _yield$_awaitAsyncGen, value, doneReading, chunkValue, lines, line, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            reader = body.getReader();
            decoder = new TextDecoder('utf-8');
            buffer = '';
            done = false;
            partial = {
              type: 'markdown',
              content: '',
              meta: {
                inputOutputDiffRatio: ''
              },
              rovoActions: []
            };
          case 6:
            if (done) {
              _context.next = 30;
              break;
            }
            _context.next = 9;
            return _awaitAsyncGenerator(reader.read());
          case 9:
            _yield$_awaitAsyncGen = _context.sent;
            value = _yield$_awaitAsyncGen.value;
            doneReading = _yield$_awaitAsyncGen.done;
            done = doneReading;
            chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;
            // Split the buffer by line breaks
            lines = buffer.split('\n'); // Process all complete lines, except for the last one (which might be incomplete)
          case 16:
            if (!(lines.length > 1)) {
              _context.next = 27;
              break;
            }
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            line = lines.shift();
            data = JSON.parse(line);
            if (!(data.generatedContent === null)) {
              _context.next = 23;
              break;
            }
            _context.next = 22;
            return handleLineNoGeneratedContent({
              cacheKey: cacheKey,
              selection: selection,
              data: data
            });
          case 22:
            return _context.abrupt("return", _context.sent);
          case 23:
            _context.next = 25;
            return handleLine({
              cacheKey: cacheKey,
              selection: selection,
              isConvoAI: isConvoAI,
              streamContentProcessor: streamContentProcessor,
              partial: partial,
              data: data
            });
          case 25:
            _context.next = 16;
            break;
          case 27:
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
            _context.next = 6;
            break;
          case 30:
            _context.next = 32;
            return handleLoaded({
              cacheKey: cacheKey,
              selectionType: selectionType,
              selection: selection,
              streamContentProcessor: streamContentProcessor,
              isComplete: isComplete,
              partial: partial
            });
          case 32:
            return _context.abrupt("return", _context.sent);
          case 35:
            _context.prev = 35;
            _context.t0 = _context["catch"](0);
            _context.next = 39;
            return {
              type: 'error',
              errorInfo: {
                failureReason: FAILURE_REASON.API_FAIL,
                statusCode: response.status,
                errorContent: sanitizeErrorContent(_context.t0)
              }
            };
          case 39:
            return _context.abrupt("return", _context.sent);
          case 40:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 35]]);
    })();
  });
  return _streamingBody.apply(this, arguments);
}
function makeEndpoint(_ref12) {
  var endpoint = _ref12.endpoint,
    channelId = _ref12.channelId;
  var actualEndpoint = endpoint;

  // Using a stateful endpoint
  if (channelId) {
    actualEndpoint = "".concat(endpoint, "/").concat(channelId, "/message/stream");
  }
  return actualEndpoint;
}
function makeHeaders(_ref13) {
  var product = _ref13.product,
    experienceId = _ref13.experienceId;
  return _objectSpread(_objectSpread({
    'Content-Type': 'application/json;charset=UTF-8',
    'X-Experience-Id': experienceId
  }, getXChannelIdHeader(experienceId)), getXProductHeader(product));
}
// experienceId and channelId are for convoai/assistance-service
export function startStreaming(_x3) {
  return _startStreaming.apply(this, arguments);
}
function _startStreaming() {
  _startStreaming = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
    var abortController, cacheKey, selectionType, product, getFetchCustomHeaders, channelId, callback, streamContentProcessor, isComplete, requestOptions, selection, isConvoAI, experienceId, endpoint, payload, actualEndpoint, fetchInit, fetchCustomHeaders, response, traceId, streaming, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          abortController = options.abortController, cacheKey = options.cacheKey, selectionType = options.selectionType, product = options.product, getFetchCustomHeaders = options.getFetchCustomHeaders, channelId = options.channelId, callback = options.callback, streamContentProcessor = options.streamContentProcessor, isComplete = options.isComplete, requestOptions = options.requestOptions;
          if (!('response' in requestOptions)) {
            _context3.next = 4;
            break;
          }
          callback(requestOptions.response);
          return _context3.abrupt("return");
        case 4:
          selection = requestOptions.selection, isConvoAI = requestOptions.isConvoAI, experienceId = requestOptions.experienceId, endpoint = requestOptions.endpoint, payload = requestOptions.payload;
          _context3.prev = 5;
          actualEndpoint = makeEndpoint({
            endpoint: endpoint,
            channelId: channelId
          });
          fetchInit = {
            method: 'POST',
            headers: makeHeaders({
              product: product,
              experienceId: experienceId
            }),
            body: payload,
            credentials: 'include',
            signal: abortController.signal,
            mode: 'cors'
          };
          fetchCustomHeaders = (getFetchCustomHeaders === null || getFetchCustomHeaders === void 0 ? void 0 : getFetchCustomHeaders(endpoint, fetchInit)) || {};
          _context3.next = 11;
          return fetch(actualEndpoint, _objectSpread(_objectSpread({}, fetchInit), {}, {
            headers: _objectSpread(_objectSpread({}, fetchInit.headers), fetchCustomHeaders)
          }));
        case 11:
          response = _context3.sent;
          traceId = response.headers.get('X-Trace-Id') || response.headers.get('Atl-Traceid');
          if (traceId) {
            callback({
              type: 'update traceIds',
              context: {
                traceIds: [traceId]
              }
            });
          }
          if (response.ok) {
            _context3.next = 20;
            break;
          }
          _context3.t0 = callback;
          _context3.next = 18;
          return handleResponseNotOK({
            cacheKey: cacheKey,
            selection: selection,
            response: response
          });
        case 18:
          _context3.t1 = _context3.sent;
          return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));
        case 20:
          if (response.body) {
            _context3.next = 23;
            break;
          }
          callback(handleNoResponseBody(response));
          return _context3.abrupt("return");
        case 23:
          streaming = streamingBody({
            cacheKey: cacheKey,
            selectionType: selectionType,
            selection: selection,
            isConvoAI: isConvoAI,
            streamContentProcessor: streamContentProcessor,
            isComplete: isComplete,
            response: response,
            body: response.body
          });
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context3.prev = 26;
          _iterator = _asyncIterator(streaming);
        case 28:
          _context3.next = 30;
          return _iterator.next();
        case 30:
          if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
            _context3.next = 38;
            break;
          }
          item = _step.value;
          callback(item);
          // If we have a response other than stream (which means there is an error), we should stop the streaming
          if (!(item.type !== 'stream')) {
            _context3.next = 35;
            break;
          }
          return _context3.abrupt("return");
        case 35:
          _iteratorAbruptCompletion = false;
          _context3.next = 28;
          break;
        case 38:
          _context3.next = 44;
          break;
        case 40:
          _context3.prev = 40;
          _context3.t2 = _context3["catch"](26);
          _didIteratorError = true;
          _iteratorError = _context3.t2;
        case 44:
          _context3.prev = 44;
          _context3.prev = 45;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context3.next = 49;
            break;
          }
          _context3.next = 49;
          return _iterator.return();
        case 49:
          _context3.prev = 49;
          if (!_didIteratorError) {
            _context3.next = 52;
            break;
          }
          throw _iteratorError;
        case 52:
          return _context3.finish(49);
        case 53:
          return _context3.finish(44);
        case 54:
          _context3.next = 59;
          break;
        case 56:
          _context3.prev = 56;
          _context3.t3 = _context3["catch"](5);
          callback(handleRequestError(_context3.t3));
        case 59:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[5, 56], [26, 40, 44, 54], [45,, 49, 53]]);
  }));
  return _startStreaming.apply(this, arguments);
}